/**
 * 
 * @param {{ required?: boolean | (values: any, form: any) => boolean}} field descriptor
 * @param {object | undefined} form 
 * 
 * @returns {boolean | undefined}
 */
export default function isFieldRequired({ required }, form) {
    return typeof required === 'function'
        ? required(form?.values, form)
        : required;
}